export var STATUS_COLORS = {
    PENDING: '#858585',
    WARNING: '#fda862',
    LIVE: '#00F0AA',
};
export var DEFAULT_APP_VERSION = 'x.x.x';
export var DEFAULT_ALIAS_VALUE = '1';
